<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="TableFilterTypeEnum.DATE">
    <ng-container *ngIf="{ start: searchBarService.filtersMap.get(this.filterName).start } as filter">
      <div [class.trigger-badge]="filter.start" (click)="openDateRangePicker($event)" [matTooltip]="dateRangeString">
        <span *ngIf="filter.start">
          <mat-icon class="edit-date-range-icon">edit_calendar</mat-icon>
          &nbsp;
        </span>
        <mat-icon
          [attr.aria-label]="'select-date-range' | translate"
          class="filter-icon"
          [color]="!filter.start && 'primary'"
          (click)="filter.start && clearDateRange($event)">
          {{ filter.start ? 'cancel' : 'filter_list' }}
        </mat-icon>
      </div>
    </ng-container>
  </ng-container>

  <div
    [class.trigger-badge]="choicesSelectedNumber"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="menu"
    *ngSwitchDefault>
    <span *ngIf="choicesSelectedNumber"> {{ choicesSelectedNumber }} &nbsp; </span>
    <mat-icon
      aria-label="Filter the column"
      class="filter-icon"
      [color]="!choicesSelectedNumber && 'primary'"
      (click)="choicesSelectedNumber && clear($event)">
      {{ choicesSelectedNumber ? 'cancel' : 'filter_list' }}
    </mat-icon>
  </div>

  <mat-menu #menu="matMenu" class="header-table-filter" (closed)="updateTrigger()">
    <button mat-menu-item (click)="$event.stopPropagation(); $event.preventDefault()">
      <mat-checkbox
        class="toggle-all"
        [checked]="keysSelectedSet.size === items?.length"
        (change)="toggleAllFilters()"
        (click)="$event.stopPropagation()"></mat-checkbox>
      <mat-form-field appearance="outline" class="shrink" (click)="$event.stopPropagation(); $event.preventDefault()">
        <mat-icon matPrefix>search</mat-icon>
        <input
          #input
          (blur)="input.focus()"
          [placeholder]="searchPlaceholderKey | translate"
          autocomplete="off"
          type="text"
          [formControl]="searchCtrl"
          matInput />
      </mat-form-field>
    </button>
    <button
      mat-menu-item
      *ngFor="let choice of items$ | async"
      (click)="toggleFilter(choice.id); $event.stopPropagation()">
      <mat-checkbox
        [checked]="keysSelectedSet.has(choice.id)"
        (change)="toggleFilter(choice.id)"
        (click)="$event.stopPropagation()"
        >{{ choice.label }}
      </mat-checkbox>
    </button>
  </mat-menu>
</ng-container>
